module.exports = __webpack_public_path__ + "img/867814.36db69f9.jpg";